import { render } from "./dsp-title.vue?vue&type=template&id=4fa99cf9"
import script from "./dsp-title.js?vue&type=script&lang=js"
export * from "./dsp-title.js?vue&type=script&lang=js"

import "./dsp-title.vue?vue&type=style&index=0&id=4fa99cf9&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__